import { ApplicationConfig } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { ErmaPreset } from './Presets/erma.preset';;

/**
 * Konfig bootstrap. Od verze primeng 18 se tu zavádějí témta. Protože žádné nové nevyhovuje, tak je použito css tématu nova z verze 13. Je umístěné v assets.
 */
export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimationsAsync(),
    providePrimeNG({
      translation: {
        noFileChosenMessage: 'Nebyl vybrán soubor'
      },
      theme: {
        preset: ErmaPreset,
        options: {
          prefix: 'erma',
          darkModeSelector: false || 'none'
        }
      }
    })
  ]
};
